<div class="d-flex align-items-end">
    <zui-select #pageSizeSelect (change)="onSelectionChange($event)">
        <zui-select-option value="10">10</zui-select-option>
        <zui-select-option value="50">50</zui-select-option>
        <zui-select-option value="100">100</zui-select-option>
    </zui-select>
    <p class="ms-3 font-s">{{ 'GENERAL.ITEMS_PER_PAGE' | translate }}</p>
</div>
